/** Sentinel for unassigned enhanced-group selection (matches legacy manage page). */
export const UNASSIGNED_GROUP_ID = 0;
